import type { UiState } from 'instantsearch.js'
import { history } from 'instantsearch.js/es/lib/routers'
import { createRoot } from 'react-dom/client'
import { WP_LOCALE } from '../../../assets/utils/algolia/algoliaLocalization'
import App, { type AppProps } from './components/App'
import {
  ConfigProvider,
  type IndexName,
  type WidgetConfig
} from './components/ConfigContext'

// Only the language filter is synced to the URL (written + read back). All other
// refinements (query, group, speaker, year) stay in-memory and are intentionally
// left out of the query string. The language filter is a TagFilter (useMenu), so
// it lives under uiState.menu[`languages.fullName.${WP_LOCALE}`].
function getRouting(indexName: IndexName): AppProps<{
  lang?: string
}>['routing'] {
  return {
    router: history({ cleanUrlOnDispose: false }),
    stateMapping: {
      stateToRoute(uiState) {
        const indexState = uiState[indexName]
        return {
          lang: indexState?.menu?.[`languages.fullName.${WP_LOCALE}`]
        }
      },
      routeToState(routeState) {
        return {
          [indexName]: {
            menu: {
              [`languages.fullName.${WP_LOCALE}`]: routeState.lang
            }
          }
        } as UiState
      }
    }
  }
}

for (const container of document.querySelectorAll<HTMLElement>(
  '[data-sermons-list-config]'
)) {
  const configJSON = container.dataset.sermonsListConfig
  if (!configJSON) {
    console.warn('Missing data-sermons-list-config attribute')
    continue
  }
  const config = JSON.parse(configJSON) as WidgetConfig
  const routing = getRouting(config.indexName)

  const reactRoot = createRoot(container)
  reactRoot.render(
    <ConfigProvider value={config}>
      <App routing={routing} />
    </ConfigProvider>
  )
}
